module.exports = __webpack_public_path__ + "img/mobile_app_banner_fr.b0606fe3.png";